"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bufferToBlob = bufferToBlob;
exports.flatten = flatten;
exports.getValueByPath = getValueByPath;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getValueByPath(data, path) {
  var value;
  if (!data || !path) return value;
  if (path.includes('.')) value = path.split('.').reduce(function (parent, prop) {
    return parent ? parent[prop] : undefined;
  }, data);else value = data[path];
  return value;
}
function flatten(array) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return array.flatMap(function (_ref) {
    var children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return [_objectSpread(_objectSpread({}, rest), {}, {
      step: step
    })].concat((0, _toConsumableArray2.default)(children ? flatten(children, step + 1) : []));
  });
}
function bufferToBlob(buf) {
  if (!buf || !buf.length) return undefined;
  try {
    var blob = new Blob([buf]);
    return blob;
  } catch (err) {
    var ab = new ArrayBuffer(buf.length);
    var uintArray = new Uint8Array(ab);
    for (var i = 0; i < buf.length; ++i) {
      uintArray[i] = buf[i];
    }
    var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
    var bb = new BlobBuilder();
    bb.append(ab);
    var _blob = bb.getBlob();
    return _blob;
  }
}